import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { wrapCreateBrowserRouterV7 } from '@sentry/react'
import { ServiceError } from 'entities/Sentry/ui/ServiceError'
import { type EntitiesStore } from 'entities/EntitiesExport'
import { ProviderEntities } from 'entities/EntitiesExport/context/entitiesContext'
import { Sidebar } from 'widgets/Sidebar'
import { PresentationModeLayout } from 'widgets/PresentationMode'
import { type CallPopUpGlobalStore } from 'widgets/CallPopUp'
import { ProviderCallPopUpGlobal } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import { RootLayout } from 'app/shared/layouts'
import AuthLayout from './layouts/AuthLayout'

const routes = createRoutesFromElements(
  <Route element={<PresentationModeLayout />}>
    <Route element={<RootLayout />} errorElement={<ServiceError name='sidebar' />}>
      <Route element={<AuthLayout />}>
        <Route path='/*' element={<Sidebar />} />
      </Route>
    </Route>
  </Route>
)

const router = wrapCreateBrowserRouterV7(createBrowserRouter)(routes)

type ISidebarServiceProps = {
  entities: EntitiesStore
  callPopUpGlobalStore: CallPopUpGlobalStore
}

export const SidebarService = ({ entities, callPopUpGlobalStore }: ISidebarServiceProps) => (
  <ProviderEntities entities={entities}>
    <ProviderCallPopUpGlobal value={callPopUpGlobalStore}>
      <RouterProvider router={router} />
    </ProviderCallPopUpGlobal>
  </ProviderEntities>
)
